module.exports = __webpack_public_path__ + "static/media/mobcovid.dca44268.webp";